import properties from "Assets/svg/menu/Specifications_nv.svg";
import projects from "Assets/svg/menu/Project_nv.svg";
import invoices from "Assets/svg/menu/invoices.svg";
import customers from "Assets/svg/menu/Customer_nv.svg";
import construction from "Assets/svg/menu/construction.svg";
import users from "Assets/svg/menu/users.svg";
import design from "Assets/svg/menu/design.svg";
import patterns from "Assets/svg/menu/Pattern_nv.svg";
import statistics from "Assets/svg/menu/Statistics_nv.svg";
import HomeIcon from "Assets/svg/menu/Home_nv.svg";
import contract from "Assets/svg/menu/contract.svg";
import profit from "Assets/svg/menu/profit.svg";
// user accsess:  1 admin -  2 namayande  - 5 nazer

export default {
  Category: [
    {
      menu_title: "home",
      menu_icon: HomeIcon,
      path: "/dashboard/home",
      authorize: true,
      enable: true,
      keyStorage: "",
      userAccess: ["1", "2", "3","5"],
    },
    {
      menu_title: "projects",
      menu_icon: projects,
      path: "/dashboard/projects",
      authorize: true,
      enable: true,
      keyStorage: "",
      userAccess: ["1", "2", "3","5"],
    },
    // {
    //   menu_title: "design",
    //   menu_icon: design,
    //   path: "/design",
    //   authorize: true,
    //   enable: true,
    //   keyStorage: "",
    //   userAccess: ["1", "2", "3","5"],
    // },
    // {
    //   menu_title: "invoices",
    //   menu_icon: invoices,
    //   path: "/dashboard/invoices",
    //   authorize: true,
    //   enable: true,
    //   keyStorage: "",
    //   userAccess: ["1", "2", "3","5"],
    // },
    // {
    //   menu_title: "contract",
    //   menu_icon: contract,
    //   path: "/dashboard/contract",
    //   authorize: true,
    //   enable: true,
    //   keyStorage: "",
    //   userAccess: ["1", "2", "3","5"],
    // },
    // {
    //   menu_title: "construction",
    //   menu_icon: construction,
    //   path: "/dashboard/construction",
    //   authorize: true,
    //   enable: true,
    //   keyStorage: "",
    //   userAccess: ["1", "2", "3","5"],
    // },
    // {
    //   menu_title: "profit",
    //   menu_icon: profit,
    //   path: "/dashboard/profit",
    //   authorize: true,
    //   enable: true,
    //   keyStorage: "",
    //   userAccess: ["1", "2", "3","5"],
    // },
    {
      menu_title: "customers",
      menu_icon: customers,
      path: "/dashboard/customers",
      authorize: true,
      enable: true,
      keyStorage: "",
      userAccess: ["1", "2","5"],
    },
    {
      menu_title: "properties",
      menu_icon: properties,
      path: "/dashboard/properties",
      authorize: true,
      enable: true,
      keyStorage: "",
      userAccess: ["1", "2","5"],
    },
    {
      menu_title: "patterns",
      menu_icon: patterns,
      path: "/dashboard/patterns",
      authorize: true,
      enable: true,
      keyStorage: "templateRules",
      userAccess: ["1", "2","5"],
    },
    // {
    //   menu_title: "users",
    //   menu_icon: users,
    //   path: "/dashboard/users",
    //   authorize: true,
    //   enable: true,
    //   keyStorage: "users",
    //   userAccess: ["1"],
    // },
    {
      menu_title: "statistic",
      menu_icon: statistics,
      path: "/dashboard/statistics",
      authorize: true,
      enable: false,
      keyStorage: "",
      userAccess: ["1", "2", "3","5"],
    },

  ],
};
